<template>
  <footer class="com-footer">
    <div class="footer-content">
      <div class="footer-link clearfix">
        <div class="footer-column">
          <dl>
            <dt>用户帮助</dt>
            <dd>
              <a rel="nofollow" href="http://www.meituan.com/help/selfservice" target="_blank">申请退款</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="http://www.meituan.com/help/selfservice?tab=2"
                target="_blank"
              >查看美团券密码</a>
            </dd>
            <dd>
              <a rel="nofollow" href="http://www.meituan.com/help/faq" target="_blank">常见问题</a>
            </dd>
            <dd>
              <a rel="nofollow" href="http://www.meituan.com/about/terms" target="_blank">用户协议</a>
            </dd>
            <dd>
              <a rel="nofollow" href="http://www.meituan.com/about/privacy" target="_blank">隐私政策</a>
            </dd>
            <dd>
              <a rel="nofollow" href="http://www.meituan.com/about/anticheat" target="_blank">反诈骗公告</a>
            </dd>
          </dl>
          <dl>
            <dt>美团服务</dt>
            <dd>
              <a href="http://waimai.meituan.com/" target="_blank">美团外卖</a>
            </dd>
            <dd>
              <a href="http://hotel.meituan.com/" target="_blank">美团酒店</a>
            </dd>
            <dd>
              <a href="http://maoyan.com/" target="_blank">猫眼电影</a>
            </dd>
            <dd>
              <a href="https://peisong.meituan.com/" target="_blank">美团配送</a>
            </dd>
            <dd>
              <a href="https://www.mtyun.com/" target="_blank">美团云</a>
            </dd>
            <dd>
              <a href="http://www.dianping.com/" target="_blank">大众点评</a>
            </dd>
            <dd>
              <a href="https://phoenix.meituan.com/" target="_blank">榛果民宿</a>
            </dd>
            <dd>
              <a href="https://mad.meituan.com" target="_blank">无人配送</a>
            </dd>
          </dl>
        </div>
        <div class="footer-column">
          <dl>
            <dt>商家合作</dt>
            <dd>
              <a
                rel="nofollow"
                href="https://ecom.meituan.com/bizsettle/settle?utm_source=mt_C_my"
                target="_blank"
              >美食商家入驻(非外卖)</a>
            </dd>
            <dd>
              <a href="https://kd.meituan.com/" target="_blank">美团外卖开店申请</a>
            </dd>
            <dd>
              <a
                href="http://shouyin.meituan.com?utm_source=inner&amp;utm_medium=mtpc"
                target="_blank"
              >美团收银官网</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="http://page.peisong.meituan.com/apply/join"
                target="_blank"
              >外卖配送加盟申请</a>
            </dd>
            <dd>
              <a href="https://xue.meituan.com/?from=mtpc" target="_blank">美团点评餐饮学院</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="http://ruzhu.meituan.com/ruzhu/index.html"
                target="_blank"
              >酒店商家入驻</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="https://i.meituan.com/awp/h5/trip/business/cooperation/index.html?client=pc"
                target="_blank"
              >境内度假商家入驻</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="https://e.dianping.com/claimcpc/page/index?source=mt"
                target="_blank"
              >综合商家入驻</a>
            </dd>
            <dd>
              <a rel="nofollow" href="https://phoenix.meituan.com/about/" target="_blank">榛果民宿房东商家入驻</a>
            </dd>
            <dd>
              <a href="http://pc.meituan.com/?activity_code=mtpcdb" target="_blank">商家开票申请</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="https://h5.youzan.com/v2/feature/nALm22bkFF?dc_ps=2039811416638097413.200001"
                target="_blank"
              >美团点评智能收银机</a>
            </dd>
            <dd>
              <a rel="nofollow" href="http://developer.meituan.com/" target="_blank">聚宝盆餐饮开放平台</a>
            </dd>
            <dd>
              <a rel="nofollow" href="http://smartpay.meituan.com/" target="_blank">美团智能支付</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="https://paidui.meituan.com/?activity_code=167_00038050"
                target="_blank"
              >免费使用美团排队</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="https://i.meituan.com/awp/hfe/block/6c4bec785dce/11188/index.html"
                target="_blank"
              >快驴进货商家合作</a>
            </dd>
            <dd>
              <a rel="nofollow" href="https://shangou.meituan.com/joinin" target="_blank">美团闪购商家入驻</a>
            </dd>
          </dl>
        </div>
        <div class="footer-column">
          <dl>
            <dt>代理商加盟</dt>
            <dd>
              <a
                rel="nofollow"
                href="https://i.meituan.com/awp/hfe/block/4544/index.html"
                target="_blank"
              >智能支付渠道加盟商招募</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="https://daili.meituan.com/?comeFrom=mtwebBusinesscoopd"
                target="_blank"
              >到店餐饮代理商招募</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="http://www.dianping.com/apollo/agent/index?source=mtpcd"
                target="_blank"
              >非餐饮代理商招募</a>
            </dd>
            <dd>
              <a rel="nofollow" href="http://union.meituan.com/" target="_blank">美团联盟</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="https://store.meituan.com/distribution/broadcast"
                target="_blank"
              >美团收银招募线上分销商</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="https://agent.meituan.com/zhaoshang?entry=5"
                target="_blank"
              >美团点评5S服务商招募</a>
            </dd>
          </dl>
          <dl>
            <dt>行业规范</dt>
            <dd>
              <a
                rel="nofollow"
                href="http://www.meituan.com/about/saferule"
                target="_blank"
              >美团点评餐饮安全管理办法</a>
            </dd>
          </dl>
          <dl>
            <dt>廉正举报</dt>
            <dd>
              <a rel="nofollow" href="mailto:lianzheng@meituan.com" target="_self">廉政邮箱</a>
            </dd>
          </dl>
        </div>
        <div class="footer-column">
          <dl>
            <dt>关注美团</dt>
            <dd>
              <a rel="nofollow" href="http://weibo.com/meituan" target="_blank">美团新浪微博</a>
            </dd>
          </dl>
          <dl>
            <dt>公司信息</dt>
            <dd>
              <a rel="nofollow" href="https://about.meituan.com/" target="_blank">关于我们</a>
            </dd>
            <dd>
              <a rel="nofollow" href="https://about.meituan.com/investor.html" target="_blank">投资者关系</a>
            </dd>
            <dd>
              <a rel="nofollow" href="http://zhaopin.meituan.com/" target="_blank">加入我们</a>
            </dd>
            <dd>
              <a rel="nofollow" href="http://www.meituan.com/about/law" target="_blank">法律声明</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="http://www.meituan.com/about/bizlicense"
                target="_blank"
              >商户服务协议</a>
            </dd>
            <dd>
              <a
                rel="nofollow"
                href="https://dpapp-appeal.meituan.com/#/shopCreditRegulationPC"
                target="_blank"
              >商户诚信公约及管理办法</a>
            </dd>
          </dl>
        </div>
        <div class="footer-column">
          <dl>
            <dt>消费者服务热线</dt>
            <dd>外卖消费者：
              <a rel="nofollow" href="tel:10109777" target="_blank">10109777</a>
            </dd>
            <dd>猫眼消费者：
              <a rel="nofollow" href="tel:10105335" target="_blank">10105335</a>
            </dd>
            <dd>其他消费者：
              <a rel="nofollow" href="tel:10107888" target="_blank">10107888</a>
            </dd>
          </dl>
          <dl>
            <dt>商家服务热线</dt>
            <dd>外卖&amp;餐饮商家：
              <a rel="nofollow" href="tel:10105557" target="_blank">10105557</a>
            </dd>
            <dd>休闲娱乐、丽人、ktv、教育、结婚、亲子、家装等商家：
              <a rel="nofollow" href="tel:10100107" target="_blank">10100107</a>
            </dd>
          </dl>
          <dl>
            <dt>投诉举报热线</dt>
            <dd>违法和不良信息举报电话：
              <a rel="nofollow" href="tel:4006018900" target="_blank">4006018900</a>
            </dd>
            <dd>举报邮箱：
              <a
                rel="nofollow"
                href="mailto:tousujubao@meituan.com"
                target="_self"
              >tousujubao@meituan.com</a>
            </dd>
          </dl>
          <dl>
            <dt>
              <a
                rel="nofollow"
                href="https://ecom.meituan.com/bizsettle/settle/merchantsSettle"
                target="_blank"
              >商家自助入驻美团入口</a>
            </dt>
          </dl>
        </div>
      </div>
      <div class="footer-copyright clearfix">
        <div class="footer-copyright-left">
          <p>©美团网团购 meituan.com
            <a
              href="http://www.beianbeian.com/beianxinxi/283f39a9-4c00-427a-97ef-3c7a9e1e0af1.html"
            >京ICP证070791号</a>
            <a href="http://www.miitbeian.gov.cn/">京ICP备10211739号</a>
            <a href="https://www.meituan.com/about/rules" target="_blank">电子公告服务规则</a>
          </p>
          <p>
            <a
              href="https://i.meituan.com/brunch/default/right"
              target="_blank"
            >广播电视节目制作经营许可证（京）字第03889号</a>
          </p>
        </div>
        <div class="footer-copyright-right">
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502025545"
            target="_blank"
          >京公网安备11010502025545号</a>
          <div class="footer-copyright-cert">
            <a
              class="sp-ft sp-ft--record"
              href="https://www.meituan.com/about/openinfo"
              title="备案信息"
              target="_blank"
            >备案信息</a>
            <a
              class="sp-ft sp-ft--knet"
              href="http://t.knet.cn/index_new.jsp"
              title="可信网站认证"
              target="_blank"
            >可信网站</a>
            <a
              class="sp-ft sp-ft--12315"
              href="http://www.bj315.org/xfwq/lstd/201209/t20120910_3344.shtml?dnrpluojqxbceiqq"
              title="12315消费争议"
              target="_blank"
            >12315消费争议</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {

}
</script>

<style lang="less" scoped>
.com-footer {
  background: #f8f8f8
}

.com-footer .footer-content {
  width: 1190px;
  margin: 0 auto;
  color: #333;
  font-size: 12px;
  line-height: 2;
  box-sizing: border-box;
  text-align: left
}

.com-footer .footer-content p {
  margin: 0
}

.com-footer .footer-content .footer-link {
  padding: 40px 45px;
  border-bottom: 1px solid #E5E5E5
}

.com-footer .footer-content .footer-link .footer-column {
  width: 20%;
  float: left
}

.com-footer .footer-content .footer-link dl {
  padding-bottom: 20px;
  color: #666
}

.com-footer .footer-content .footer-link dl dt {
  font-size: 14px;
  font-weight: 500
}

.com-footer .footer-content .footer-link dl a {
  color: #666
}

.com-footer .footer-content .footer-link dl a:hover {
  color: #31BBAC
}

.com-footer .footer-content .footer-copyright {
  color: #999;
  padding-left: 20px;
  padding-top: 15px;
  padding-bottom: 30px;
  line-height: 1.6
}

.com-footer .footer-content .footer-copyright a {
  color: #999
}

.com-footer .footer-content .footer-copyright a:hover {
  color: #31BBAC
}

.com-footer .footer-content .footer-copyright .footer-copyright-left {
  float: left
}

.com-footer .footer-content .footer-copyright .footer-copyright-right {
  float: right;
  text-align: right
}

.com-footer .footer-content .footer-copyright .footer-copyright-cert {
  text-align: left;
  padding-top: 6px
}

.com-footer .footer-content .footer-copyright .footer-copyright-cert a.sp-ft {
  display: inline-block;
  overflow: hidden;
  text-indent: -1000px;
  height: 38px;
  background-repeat: no-repeat;
  margin-right: 2px
}

.com-footer .footer-content .footer-copyright .footer-copyright-cert .sp-ft--record {
  width: 109px;
  background-position: 0 -167px
}

.com-footer .footer-content .footer-copyright .footer-copyright-cert .sp-ft--knet {
  width: 107px;
  background-position: 0 -127px
}

.com-footer .footer-content .footer-copyright .footer-copyright-cert .sp-ft--12315 {
  width: 107px;
  background-position: 0 -40px
}

@media screen and (max-width:1200px) {
  .com-footer .footer-content {
    width: 960px
  }

  .com-footer .footer-content .footer-title-module {
    padding-right: 40px
  }

  .com-footer .footer-content .footer-title {
    margin-left: 0
  }

  .com-footer .footer-content .footer-search-block,
  .com-footer .footer-content .footer-search-hotword {
    width: 500px
  }
}

.com-footer li,
.com-footer ul {
  padding: 0;
  margin: 0
}

.com-footer .clearfix:after {
  content: " ";
  visibility: hidden;
  display: block;
  height: 0;
  clear: both
}

.com-footer input {
  outline: 0
}

.com-footer a {
  text-decoration: none
}

.com-footer li {
  list-style: none
}

.com-footer dd,
.com-footer dl {
  margin: 0
}

</style>
